// Centralised field copy + radio options for the redesigned edit-profile cards.
// (Kept as local constants — like the legacy form — rather than i18n keys; the
// rest of the app's form notes follow the same pattern.)

type RadioOption<TValue> = {
  label: string
  value: TValue
}

export const STATUS_OPTIONS: RadioOption<boolean>[] = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false }
]

export const INCIDENT_EMAIL_NOTIFICATION_OPTIONS: RadioOption<boolean>[] = [
  { label: 'Enabled', value: true },
  { label: 'Disabled', value: false }
]

export const ALLERGY_OPTIONS: RadioOption<string>[] = [
  { label: 'Yes', value: 'Yes' },
  { label: 'None known', value: 'None known' }
]

export const GP_CONNECT_OPTIONS: RadioOption<boolean>[] = [
  { label: 'Clinical Access', value: true },
  { label: 'Non-Clinical Access', value: false }
]

export const STATUS_NOTE = 'Only active team members can access Log my Care'

export const INCIDENT_EMAIL_NOTIFICATION_NOTE =
  'Receive an email when an incident is logged in any home this user has access to. Incident details are not included in the email.'

export const BLOCK_NAME_CHANGE_NOTE =
  "Changes to this team member's name has been disabled because they have access to multiple sites. Please contact support if you'd like to change their name."

export const NHS_RBAC_HELPER =
  "Role as per NHS role based access control. It's mandatory for all staff to complete training for accessing the London Care Record."
